'use strict';

angular.module('membership')
  .controller('ModifyAgentCtrl', [
    '$scope', 'modifyAgentViewModel', '$modalInstance', '$$selectedId', '$$selectedName', '$$ownershipvm',
    function ($scope, viewModel, modalInstance, $$selectedId, $$selectedName, $$ownershipvm) {
      var vm = new viewModel(modalInstance, $$selectedId, $$selectedName, $$ownershipvm);

      $scope.vm = vm;
      
    }
  ]);